import { Card as PrCard, type CardProps } from 'primereact/card'

/**
 * Paylaşılan Card (PrimeReact Card sarmalayıcı — Reuse Mandate). Tek tip kart görünümü (zemin/kenar/
 * radius/gölge) `design-tokens.css` + `primereact-overrides.css`'teki `.p-card` kurallarından gelir;
 * ekranlar Card'ı doğrudan `primereact/card`'tan değil buradan alır. Tüm `CardProps` aynen geçer.
 */
export default function Card(props: Readonly<CardProps>) {
  return <PrCard {...props} />
}
